export default __webpack_public_path__ + "static/media/173.9c31e553.gif";